import { getDeviceIdSync } from "@/lib/device-fingerprint";

function getDeviceIdHeader(): Record<string, string> {
  const deviceId = getDeviceIdSync();
  return deviceId ? { "x-device-id": deviceId } : {};
}

export async function getRequest(params: any) {
  const queryParams = {
    lang: params.lang ?? "",
    path: JSON.stringify(params.path) ?? "",
    skipCache: params.skipCache ?? false,
  };
  const query = new URLSearchParams(queryParams);
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_WEB_URL}/api/request?${query.toString()}`,
    { headers: { "x-oc-image-dimension": "900x600", ...getDeviceIdHeader() } },
  );
  return await response.json();
}

export async function postRequest(params: any) {
  const method = params.method ?? "POST";
  const methodLower = String(method).toLowerCase();
  const headers = { ...getDeviceIdHeader(), ...(params.headers ?? {}) };
  const body = params.body ?? {};
  let data;
  const lang = params.lang ?? "";
  const path = params.path ?? "/";
  const requestBody = {
    lang,
    method,
    path,
  };
  if (params.formData && params.formData instanceof FormData) {
    data = params.formData;
    data.append("jsonStuff", JSON.stringify(requestBody));
  } else {
    data = JSON.stringify({
      ...requestBody,
      data: body,
    });
  }

  const response = await fetch(`/api/request`, {
    method: "POST",
    headers,
    body: data,
  });

  if (response.status === 429 && (methodLower === "post" || methodLower === "put")) {
    return {
      success: 0,
      tooManyAttempts: true,
      error: "Too many attempts. Please try again later.",
      data: null,
    };
  }

  try {
    return await response.json();
  } catch {
    // Fallback if the response is not JSON for any reason.
    return {
      success: 0,
      error: "Request failed. Please try again later.",
      data: null,
    };
  }
}
